module.exports = __webpack_public_path__ + "static/media/svg-goutte-vide-bleue.150c2b41.svg";